import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        "flex min-h-[96px] w-full rounded-nav border border-waves-line bg-white px-4 py-3 text-[15px] leading-relaxed text-waves-ink transition-colors placeholder:text-waves-muted focus-visible:border-waves-zee focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-waves-zee/25 disabled:cursor-not-allowed disabled:bg-waves-subtle disabled:opacity-70",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";

export { Textarea };
